import { AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivityService } from '@app/main/activities/services/activity.service';
import { ProductivityBarComponent as ActivitiesProductivityBarComponent } from '@app/main/activities/shared/productivity-bar/productivity-bar.component';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { CalculationTimeAndAttendanceDto, TimeAndAttendanceServiceProxy } from '@shared/service-proxies/service-proxies';
import { DateTime } from 'luxon';
import { DashboardUserTimeDataService } from '../dashboard-user-time-data.service';
@Component({
    standalone: false,
    selector: 'app-productivity-bar',
    templateUrl: './productivity-bar.component.html',
    styleUrls: ['./productivity-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductivityBarComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(ActivitiesProductivityBarComponent) private activitiesProductivityBar: ActivitiesProductivityBarComponent;
    private activitiesBarViewReady = false;
    private pendingProductivityBarRefreshDate: Date | null = null;
    isDashboard: string = 'Dashboard';
    userStats: CalculationTimeAndAttendanceDto;
    productivityPercentage: number;
    constructor(
        private _monitorService: MonitoringService,
        private _activityService: ActivityService,
        private cdRef: ChangeDetectorRef,
        private _timeAndAttend: TimeAndAttendanceServiceProxy,
        private _dashboardUserTimeDataService: DashboardUserTimeDataService) { }
    ProductiveBarStartTime;
    ProductiveBarEndTime;
    dateTime = new Date();
    ngOnInit(): void {
        this.getTenantId();
        this.getUserId();
        let date = new Date();
        localStorage.setItem('dashboardProductivity', this.isDashboard);
        this.getUserArrivalTime(date);
        this._activityService.selectView('day', date);
    }
    getUserArrivalTime(date) {
        try {
            this._monitorService.logTrace("UI-getUserArrivalTime", { "getUserArrivalTime ": "getProductiviyBarStartTime:called " + this + this.dateTime });
            this.ProductiveBarStartTime = -1;
            this.ProductiveBarEndTime = -1;
            this.userStats = undefined;
            date.setHours(0, 0, 0, 0);
            let d = new Date();
            this._timeAndAttend.getUserCalculationBaseOnActivity(abp.session.userId, abp.session.tenantId, this._activityService.toApiCalendarDate(date), d.getTimezoneOffset(), this._activityService.toApiCalendarDate(d), this._activityService.toApiCalendarDate(date), undefined).subscribe(result => {
                this.productivityPercentage = result.productivityPercentage;
                this._dashboardUserTimeDataService.setUserTimeDetails(result);
                abp.event.trigger('passDataToUserInfoSection', result);
                this.cdRef.detectChanges();
                var d = new Date();
                this.userStats = result;
                let t1 = this._activityService.setZeroTimeForLocalDate(date);
                let t2 = this._activityService.setZeroTimeForLocalDate(d);
                if (t1.getDate() == t2.getDate() && t1.getMonth() == t2.getMonth() && t1.getFullYear() == t2.getFullYear()) {
                    if (result.isPRodTimePresent) {
                        this.ProductiveBarStartTime = this.getArrivalTime(result.productivityBarStartTime)?.getHours();
                        if (this.ProductiveBarStartTime != undefined) {
                            if (this.ProductiveBarStartTime > 9) {
                                this.ProductiveBarStartTime = 9;
                            }
                            let currDate = new Date();
                            let currenthours = currDate.getHours() + 1;
                            let diff = currenthours - this.ProductiveBarStartTime;
                            if (diff < 11) {
                                this.ProductiveBarEndTime = this.ProductiveBarStartTime + 12;
                            }
                            else {
                                this.ProductiveBarEndTime = this.ProductiveBarStartTime + diff;
                            }
                        }
                        if (this.ProductiveBarStartTime == undefined) {
                            this.ProductiveBarStartTime = 9;
                            this.ProductiveBarEndTime = 21;
                        }
                    }
                    else {
                        this.ProductiveBarStartTime = 9;
                        this.ProductiveBarEndTime = 21;
                    }
                }
                else {
                    this.ProductiveBarStartTime = 0;
                    this.ProductiveBarEndTime = 24;
                }
                this.cdRef.detectChanges();
                this.cdRef.markForCheck();
                this.requestActivitiesProductivityBarRefresh(date);
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    ngAfterViewInit(): void {
        this.activitiesBarViewReady = true;
        if (this.pendingProductivityBarRefreshDate) {
            this.requestActivitiesProductivityBarRefresh(this.pendingProductivityBarRefreshDate);
            this.pendingProductivityBarRefreshDate = null;
        }
    }
    /** Avoids a race when getUserCalculationBaseOnActivity returns before ViewChild is ready (common on Admin My Dashboard). */
    private requestActivitiesProductivityBarRefresh(date: Date): void {
        if (!this.activitiesBarViewReady || !this.activitiesProductivityBar) {
            this.pendingProductivityBarRefreshDate = date;
            return;
        }
        this.activitiesProductivityBar.refreshProductivityBar(date);
    }
    getUserId() {
        return abp.session.userId;
    }
    getTenantId() {
        return abp.session.tenantId;
    }
    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    getArrivalTime(date: DateTime) {
        if (date?.hour == 0 && date?.minute == 0) {
            return;
        }
        let jsDate = new Date(`${date?.year}-${date?.month < 10 ? "0" + date?.month : date?.month}-${date?.day < 10 ? "0" + date?.day : date?.day}T${date?.hour < 10 ? "0" + date?.hour : date?.hour}:${date?.minute < 10 ? "0" + date?.minute : date?.minute}:00`);
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }
    ngOnDestroy() {
        localStorage.removeItem('dashboardProductivity');
    }
    RefreshProd(event: any) {
        this.getUserArrivalTime(new Date());
    }
}
